import { ThunkDispatch } from '@reduxjs/toolkit';
import TaskConversation from 'containers/Tasks/Conversation/TaskConversation';
import React, { Fragment } from 'react';
import { Helmet } from 'react-helmet';
import { navigate } from '@reach/router';
import { connect, MapStateToProps, MapDispatchToProps } from 'react-redux';
import { Beforeunload } from 'react-beforeunload';
import generateUserPermission from 'utils/permission';
import * as taskManipulate from 'store/tasks/taskManipulate';
import {
  requireDocument,
  requireDocumentFn,
} from 'store/providers/providerSlice';
import { NumberOrNull, ISearchParams, Tab } from 'store/entity/types';
import { ITasks, IUsers, RootState } from 'store/store';
import {
  EditorContainer,
  TaskDependencyNotMeetBox,
  TaskDraftBox,
} from './styles';
import messages from './Messages';
import TaskEditor from './TaskEditor';
import { display } from 'components/ErrorView/ErrorDialog';
import LogoLoading from 'components/LogoLoading';
import TaskPreferences from 'components/TaskPreferences';
import TaskEditorHeader from 'components/TaskEditorHeader';
import { IUserOption, IRoleOption } from 'components/UserSelector/UserSelector';
import notify from 'components/Notify';
import Icon from 'components/Icon';
import { createTaskFromTemplate } from 'store/tasks/taskManipulate2';
import Button from '../../../components/Button/Button';
import { setSingleTaskAccessToken } from 'store/session/SessionSlice';
import { parse } from 'query-string';
import { getAccessToken } from 'api/Utils';
import { notifyError } from 'components/Notify/Notify';
import { addGuideToList } from 'store/siteGuide/SiteGuideSlice';
import { appDispatch } from 'store/store';
import {
  ICompany,
  ICompanyProviders,
  IInvitedMember,
  TProjects,
} from 'store/companies/companiesTypes';
import {
  IAssignmentHistory,
  IAssignmentView,
  IField,
  ITask,
  TaskStatus,
} from 'store/tasks/tasksType';
import cloneDeep from 'lodash/cloneDeep';
import { IThisUserState } from 'store/thisUser/thisUserSlice';
import {
  createTask,
  createTaskFn,
  deleteSingleTaskFn,
  draftTask,
  draftTaskFn,
  duplicateTask,
  duplicateTaskFn,
  getTask,
  getTaskFn,
  markTaskAssignment,
  markTaskAssignmentFn,
  markTaskAssignmentHistory,
  markTaskAssignmentHistoryFn,
  moveToProject,
  moveToProjectFn,
  restoreTask,
  restoreTaskFn,
  searchTasks,
  searchTasksFn,
  sendMessageToAssignee,
  sendMessageToAssigneeFn,
  setDirty,
  undraftTask,
  undraftTaskFn,
  updateTask,
  updateTaskFn,
} from 'store/tasks/tasksSlice';
import { deleteSingleTask } from 'store/tasks/tasksSlice';
import {
  requireSeveralUser,
  requireSeveralUserFn,
} from 'store/users/usersSlice';
import {
  batchAddMembersToCompany,
  batchAddMembersToCompanyFn,
  getProject,
  getProjectFn,
} from 'store/companies/companiesSlice';
import { IPermission } from 'store/entity/IPermission';
import {
  isCompanyAdmin,
  isCompanyOwnerOrSupport,
} from 'store/companies/companiesUtils';
import { WindowSize } from '../../../components/TaskListView/TaskListView';
import i18n, { languageDirection } from '../../../i18n';
import UserMixpanel from '../../../utils/mixpanel/MixpanelClass';
import { OpenItemsContext } from '../../../store/context/OpenItemsContext';
import { useSafeNavigate } from '../../../context/SafeNavigate/SafeNavigateProvider';
import { black } from 'utils/style/colors';

type StateToProps = {
  company?: ICompany;
  companyOwnerId: number;
  projects: TProjects;
  relatedProviders: ICompanyProviders;
  relatedTemplate: ITask;
  tasks: ITasks;
  thisUser: IThisUserState;
  thisUserId: number;
  users: IUsers['map'];
  token?: string;
  isDirty: boolean;
};
type DispatchToProps = {
  setSingleTaskAccessToken: (token: string) => void;
  createTask: (
    task: ITask,
    dontSendMessages?: boolean
  ) => ReturnType<typeof createTaskFn>;
  deleteSingleTask: (taskId: number) => ReturnType<typeof deleteSingleTaskFn>;
  restoreTask: (taskId: number) => ReturnType<typeof restoreTaskFn>;
  getTask: (taskId: number, force?: boolean) => ReturnType<typeof getTaskFn>;
  moveToProject: (
    taskId: number,
    projectId: number
  ) => ReturnType<typeof moveToProjectFn>;
  getProject: (
    projectId: number,
    companyId: number
  ) => ReturnType<typeof getProjectFn>;
  markTaskAssignment: (
    assignment: IAssignmentView
  ) => ReturnType<typeof markTaskAssignmentFn>;
  requireDocument: (documentId: number) => ReturnType<typeof requireDocumentFn>;
  requireSeveralUser: (
    membersId: number[]
  ) => ReturnType<typeof requireSeveralUserFn>;
  searchTasks: (params: ISearchParams) => ReturnType<typeof searchTasksFn>;
  updateTask: (
    task: ITask,
    dontSendMessages?: boolean
  ) => ReturnType<typeof updateTaskFn>;
  undraftTask: (
    taskId: number,
    includeSubTasks: boolean
  ) => ReturnType<typeof undraftTaskFn>;
  draftTask: (taskId: number) => ReturnType<typeof draftTaskFn>;
  setDirty: (taskId: number, isDirty: boolean) => void;
  duplicateTask: (taskId: number) => ReturnType<typeof duplicateTaskFn>;
  sendMessageToAssignee: (
    taskId: number,
    message: string
  ) => ReturnType<typeof sendMessageToAssigneeFn>;
  addGuideToList: (key: string | Array<string>) => void;
  addMultipleMembersToCompany: (
    invitedMembers: IInvitedMember[],
    forceRename: boolean,
    companyId: number
  ) => ReturnType<typeof batchAddMembersToCompanyFn>;
  markTaskAssignmentHistory: (
    assignmentId: number,
    assignmentHistory: IAssignmentHistory[]
  ) => ReturnType<typeof markTaskAssignmentHistoryFn>;
};
export type OwnProps = {
  companyId: number;
  projectId?: number;
  tab: Tab;
  taskId?: number | string;
  parentId?: number;
  templateId?: number;
  selectedSubTaskId?: number;
  onCloseTask?: () => void;
  providerItem?: any;
  fields?: IField[];
  embedded?: boolean;
  directTask?: boolean;
  handleChangeTaskInplace?: (taskId: number) => void;
  onTaskCreate?: (taskId: number) => any;
  task: ITask;
  stickToSide?: boolean;
  windowSize: WindowSize;
  isMobile?: boolean;
  safeNavigate?: any;
  questionConfigs?: any[];
  autoFillFields?: { [key: string]: any };
  disableStack?: boolean | undefined;
};
type ComponentProps = OwnProps & StateToProps & DispatchToProps;
type ComponentStates = {
  loading: boolean;
  projectId: number;
  loadingSave: boolean;
  showDropdown: boolean;
  preferencesModal: boolean;
  changeParent: boolean;
  templateId: number;
  loadingDraft: boolean;
  foundDraftSubtask: {
    found: boolean;
    hasTaskWithNotFilledRequiredField: boolean;
  };
  editing: boolean;
  showConversation: boolean;
  scrollToSubTask?: number;
  activeAssigneeIdToShow: number | null;
};

class TaskEditorCont extends React.Component<ComponentProps, ComponentStates> {
  static contextType = OpenItemsContext;
  constructor(props: ComponentProps) {
    super(props);
    let projectId = Number(props.projectId || 0);
    if (props.task) {
      projectId = props.task.projectId as number;
    }
    this.state = {
      loading: true,
      projectId,
      loadingSave: false,
      showDropdown: false,
      preferencesModal: false,
      changeParent: false,
      templateId: this.props.templateId ? Number(this.props.templateId) : 0,
      loadingDraft: false,
      foundDraftSubtask: this.checkForDraftSubtask(),
      editing:
        Boolean(parse(window.location.search)?.editting === 'true') ||
        Boolean(
          (this.props.task && this.props.task.template) || this.props.templateId
        ),
      showConversation:
        window.location.pathname.split('/').at(-1) === 'conversation',
      activeAssigneeIdToShow: null,
    };
  }

  componentDidMount() {
    const parsed: any = parse(window.location!.search);
    parsed.tt &&
      this.props.setSingleTaskAccessToken(parsed.tt.replace(' ', '+'));
    const taskId = this.props.taskId;
    const promises = [];
    if (taskId && taskId !== 'new') {
      promises.push(
        this.props.getTask(Number(taskId)).then(() => {
          const members = this.taskMembers();
          promises.push(this.props.requireSeveralUser(members));
          if (this.props.task.parentId && this.props.thisUserId) {
            promises.push(this.props.getTask(this.props.task.parentId));
          }
        })
      );
    } else {
      const members = this.taskMembers();
      promises.push(
        this.props.requireSeveralUser(members).then(() => {
          if (this.props.parentId) {
            promises.push(this.props.getTask(this.props.parentId));
          }
        })
      );
      const availableProjects =
        (this.props.company &&
          this.getAvailableProjects(this.props.company, this.props.projects)) ||
        [];
      if (availableProjects.length === 1 && !this.props.parentId) {
        this.setState({ projectId: availableProjects[0].id });
      }
    }
    Promise.allSettled(promises)
      .catch((err) => {
        display(err);
      })
      .finally(() => {
        this.setState({ loading: false });
      });
    this.setNewCreatingTaskIfValid({} as any, {} as any);
  }

  checkForDraftSubtask(): {
    found: boolean;
    hasTaskWithNotFilledRequiredField: boolean;
  } {
    const currentId = Number(this.props.taskId);
    const ret = [...Object.values(this.props.tasks.data)].some(
      (task: ITask) => {
        return task.parentId === currentId && task.draft;
      }
    );
    const hasTaskWithNotFilledRequiredField = [
      ...Object.values(this.props.tasks.data),
    ].some((task: ITask) => {
      return (
        task.parentId === currentId &&
        task.draft &&
        task.fields?.find((it: any) => {
          return it.required && (!it.value || /^\s*$/.test(it.value));
        })
      );
    });
    return { found: ret, hasTaskWithNotFilledRequiredField };
  }
  componentWillUnmount() {
    this.props?.setDirty?.(Number(this.props.taskId) || 0, false);
  }

  componentDidUpdate(prevProps: ComponentProps, prevState: ComponentStates) {
    if (prevProps.taskId !== this.props.taskId) {
      this.props?.setDirty?.(Number(prevProps.taskId) || 0, false);
      this.props?.setDirty?.(Number(this.props.taskId) || 0, false);
    }
    const promises = [];
    if (this.props.taskId !== 'new' && prevProps.taskId !== this.props.taskId) {
      const projectId = this.props.task?.projectId;
      this.setState({ templateId: 0, editing: false });
      if (this.props.task?.parentId) {
        promises.push(this.props.getTask(this.props.task.parentId));
      }
      const members = this.taskMembers();
      promises.push(
        this.props
          .requireSeveralUser(members)
          .then(() => {
            this.setState({ projectId, loading: false });
          })
          .catch((err) => {
            display(err);
            this.setState({ loading: false });
          })
      );
    } else if (
      this.props.taskId !== 'new' &&
      prevProps.parentId !== this.props.parentId
    ) {
      promises.push(this.props.getTask(this.props.task.parentId));
    }

    if (
      this.props.taskId !== 'new' &&
      (prevProps.taskId !== this.props.taskId ||
        Object.keys(this.props.tasks.data).length !==
          Object.keys(prevProps.tasks.data).length)
    ) {
      this.setState({ foundDraftSubtask: this.checkForDraftSubtask() });
    }

    this.setNewCreatingTaskIfValid(prevProps, prevState);
    Promise.all(promises as any);
  }

  handleSetActiveAssigneeIdToShow = (asId: number | null) => {
    this.setState({ activeAssigneeIdToShow: asId });
  };

  private setNewCreatingTaskIfValid = (
    prevProps: OwnProps & StateToProps & DispatchToProps,
    prevState: ComponentStates
  ) => {
    if (
      this.props.taskId === 'new' &&
      ((this.props.taskId === 'new' && prevProps.taskId !== 'new') ||
        this.state.templateId !== prevState.templateId ||
        this.state.projectId !== prevState.projectId)
    ) {
      this.setState((prevState) => {
        let templateId = 0;
        if (this.props.templateId) {
          templateId = prevState.templateId;
        } else {
          const projTemplates =
            this.props.projects[this.state.projectId || this.props.projectId!]
              ?.templates || [];
          const foundTemplate =
            projTemplates &&
            projTemplates.find(
              (projTemplate: any) =>
                projTemplate.taskId === this.state.templateId &&
                projTemplate.allowRoot
            );
          templateId = foundTemplate
            ? this.state.templateId
            : (projTemplates &&
                projTemplates.filter((item: any) => item.allowRoot)[0]
                  ?.taskId) ||
              0;
        }
        return {
          templateId,
          editing: true,
        };
      });
    }
  };
  taskMembers = (): number[] => {
    let members = Object.keys(this.props.company?.members || {});
    if (this.props.task && members) {
      members = members.concat(Object.keys(this.props.task.assignee || {}));
      members = members.concat(Object.keys(this.props.task.followers || {}));
      this.props.task.assignmentHistoryList?.forEach(
        (a: IAssignmentHistory) => {
          a.actorId && members.push(a.actorId!.toString()!);
        }
      );
      Object.values(this.props.task.verifiers || {}).forEach(
        (verifier: IAssignmentView) => {
          members.push(verifier.userId.toString());
        }
      );
      if (this.props.task.taskPublisher?.userId) {
        members.push(this.props.task.taskPublisher.userId.toString());
      }
      if (this.props.task.subTaskPublisher?.userId) {
        members.push(this.props.task.subTaskPublisher.userId.toString());
      }
      if (this.props.task.creator) {
        members.push(this.props.task.creator.toString());
      }
    }
    return Array.from(new Set(members)).map((it) => Number(it));
  };

  handleSelectChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const name = e.target.name;
    const value = e.target.value;
    if (name === 'projectId') {
      this.props.getProject(Number(value), this.props.companyId).then(
        () => {
          this.setState((prevState) => {
            let templateId = 0;
            if (this.props.templateId) {
              templateId = prevState.templateId;
            } else {
              const tempTemplates =
                this.props.projects[Number(value)].templates;
              templateId = tempTemplates[0]?.taskId || 0;
            }
            return {
              projectId: Number(value),
              templateId,
            };
          });
        },
        (err) => {
          display(err);
        }
      );
    } else if (name === 'templateId') {
      this.setState({ templateId: Number(value) });
    }
  };

  handleSaveTask = (
    task: ITask,
    createNext: boolean = false,
    keepEditing: boolean = false,
    dontSendMessages: boolean = false
  ) => {
    const newTask = taskManipulate.stateToServer(task);
    const mx = UserMixpanel.getInstance();

    if (this.props.templateId || this.state.templateId) {
      // create a new task
      if (this.state.projectId) {
        newTask.projectId = this.state.projectId;
        if (this.props.parentId) {
          newTask.parentId = this.props.parentId;
        }
        if (newTask.templateReportOptions) {
          delete newTask.templateReportOptions;
        }
        newTask.templateId = this.props.templateId || this.state.templateId;
        this.setState({ loadingSave: true });
        return this.props
          .createTask(newTask, dontSendMessages)
          .then(({ createdTask }) => {
            mx.sendCreateTaskTrack(createdTask.title, createdTask.taskName);
            notify(i18n.t('taskCreated', { ns: 'taskManager' }));
            if (this.props.onTaskCreate) {
              this.props.onTaskCreate(createdTask.id!);
              return;
            }
            if (!createNext) {
              this.handleClickOnTask?.(
                createdTask.id,
                newTask.continueOnSubTasks ? 'info' : 'info'
              );
              this.setState({ loadingSave: false, templateId: 0 });
            } else {
              this.setState({ loadingSave: false });
            }
            this.setState({ editing: false });
            this.props.setDirty(createdTask.id, false);
          })
          .catch((err) => {
            this.setState({ loadingSave: false });
            display(err);
          });
      } else {
        notify(
          i18n.t('checkThatYouHaveSelectedProject', { ns: 'taskManager' }),
          'warning'
        );
        this.props.setDirty(newTask.id, false);
      }
    } else {
      // update a task
      this.setState({ loadingSave: true });
      return this.props.updateTask(newTask, dontSendMessages).then(
        () => {
          notify(i18n.t('taskUpdated', { ns: 'taskManager' }));
          this.setState({ loadingSave: false, editing: keepEditing });
          this.props.setDirty(newTask.id, false);
        },
        (err) => {
          this.setState({ loadingSave: false });
          display(err);
        }
      );
    }
    return null;
  };

  handleModifyTask = (task: any) => {
    const newTask = taskManipulate.stateToServer(task);
    newTask.projectId = this.state.projectId;
    return this.props.updateTask(newTask);
  };

  handleArchiveOrRestoring = (type: 'archive' | 'restore', taskId: number) => {
    const task = this.props.tasks.data[taskId];
    const updatedTask: ITask = taskManipulate.storeToServer(task);
    if (type === 'archive') {
      updatedTask.archived = true;
    } else if (type === 'restore') {
      updatedTask.archived = false;
    }
    const { title } = updatedTask;
    return this.props.updateTask(updatedTask).then(() => {
      notify(
        type === 'archive'
          ? messages.taskArchived(title)
          : messages.taskRestored(title)
      );
    });
  };

  handleDraftTask = (task: ITask) => {
    return this.props.draftTask(task.id).then(() => {
      this.setState({ editing: false });
      notify(messages.taskDrafted(task.taskName));
    });
  };

  handleUpdateAssignmentTask = (assignment: IAssignmentView) => {
    this.setState({ loadingSave: true });
    this.props.markTaskAssignment(assignment).finally(() => {
      this.setState({ loadingSave: false });
    });
  };

  handleUpdateAssignmentHistoryListTask = (
    assignmentId: number,
    assignmentHistory: IAssignmentHistory[]
  ) => {
    this.setState({ loadingSave: true });
    this.props
      .markTaskAssignmentHistory(assignmentId, assignmentHistory)
      .finally(() => {
        this.setState({ loadingSave: false });
      });
  };

  handleChangeProgress = async (
    userId: number,
    progress: number,
    status: TaskStatus,
    progressDescription: string,
    valueOverwrite?: { [key: string]: string }
  ) => {
    const { task } = this.props;
    if (!task) return;

    const updatedTask = cloneDeep(task);
    if (updatedTask.assignee[userId]) {
      updatedTask.assignee[userId].progress = progress;
      updatedTask.assignee[userId].status = status;
      updatedTask.assignee[userId].progressDescription = progressDescription;
      if (valueOverwrite) {
        updatedTask.assignee[userId].taskFieldValues = valueOverwrite;
      }
    }

    const assignment: IAssignmentView = {
      ...updatedTask.assignee[userId],
      userId,
      taskId: task.id,
      progress,
      status,
      progressDescription,
      taskFieldValues: valueOverwrite,
      type: 'does',
    };

    this.props.markTaskAssignment(assignment);
  };

  handleShowPreferencesModal = (state: boolean) => {
    this.setState({ preferencesModal: state });
  };

  handleClickOnEdit = () => {
    this.setState({ editing: true });
  };
  handleSendMessageToAssignee = (message: string) => {
    return this.props
      .sendMessageToAssignee(Number(this.props.taskId), message)
      .then(
        () => {
          notify(
            i18n.t('smsSent', { ns: 'taskManager' }),
            'successful',
            true,
            10000
          );
        },
        (e) => {
          notifyError(e, false);
        }
      );
  };
  handleDuplicateTask = () => {
    this.props.duplicateTask(Number(this.props.taskId)).then(
      ({ createdTask: d }) => {
        this.handleClickOnTask?.(d.id, 'info');
        notify(i18n.t('taskCloned', { ns: 'taskManager' }));
      },
      (reason) => {
        notifyError(reason);
      }
    );
  };
  handleCancelEdit = () => {
    this.setState({ editing: false });
  };

  handleChangeParent = (e: React.MouseEvent) => {
    e.preventDefault();
    this.setState((state) => ({ changeParent: !state.changeParent }));
  };

  handleSearchTask = (text: string, projectId: number) => {
    return new Promise((resolve, reject) => {
      this.props
        .searchTasks({
          companyId: Number(this.props.companyId),
          text,
          parentId: -1,
          archived: false,
          projectId,
        })
        .then((result) => {
          resolve(result);
        })
        .catch((err) => {
          reject(err);
        });
    });
  };

  handleChangeParentTask = (parentId: NumberOrNull | string = null) => {
    const task = taskManipulate.storeToServer(this.props.task);
    // if selected task is current task
    if (task.id !== parentId) {
      // when parentId is null, task's parent will remove
      task.parentId = parentId;
      return this.props.updateTask(task);
    } else {
      const err = {
        custom: i18n.t('aTaskCannotBeChildOfItself', { ns: 'taskManager' }),
      };
      return Promise.reject(err);
    }
  };

  handleUpdateTask = (task: ITask) => {
    this.props
      .updateTask(task)
      .then(() => {
        notify(i18n.t('taskUpdated', { ns: 'taskManager' }));
      })
      .catch((err) => {
        display(err);
      });
  };

  handleClickOnTask = (
    taskId?: number,
    tab?: Tab,
    token?: string,
    e?: React.MouseEvent
  ) => {
    const companyId = Number(this.props.companyId);
    const projectId = Number(this.props.projectId);
    if (this.props.directTask && token) {
      navigate(`/t/${companyId}/dt/${taskId}?tt=${token}`);
      return;
    }
    const projectPart =
      window.location.href?.includes('/project/') && projectId
        ? `project/${projectId}/task`
        : window.location.href?.includes('/home/')
          ? 'home'
          : 'task';
    let url = `/t/${companyId}/${projectPart}`;
    if (taskId) {
      url = `${url}/editor/${taskId}/${tab ? tab : 'info'}`;
    }
    if (e?.ctrlKey || e?.altKey || e?.metaKey || e?.shiftKey)
      window.open(url, '_blank');
    else if (this.props.embedded) {
      if (this.props.handleChangeTaskInplace)
        this.props.handleChangeTaskInplace(taskId!);
      else window.open(url, '_blank');
    } else navigate(url);
  };

  timeout: any = '';

  handleDeleteTask =
    (taskId: number, taskName: string, parentId?: number) => () => {
      return this.props.deleteSingleTask(taskId).then(() => {
        notify(messages.taskDeleted(taskName));
        this.setState({ preferencesModal: false });
        if (this.props.embedded) {
          this.props.onCloseTask?.();
          return;
        }
        const companyId = Number(this.props.companyId);
        const projectId = Number(this.props.projectId);
        const projectPart =
          window.location.href?.includes('/project/') && projectId
            ? `project/${projectId}/`
            : '';
        let url = `/t/${companyId}/${projectPart}task`;
        if (parentId) {
          url = `${url}/editor/${parentId}/info`;
        }
        navigate(url);
      });
    };

  handleRestoreTask = (taskId: number, taskName: string) => {
    return this.props.restoreTask(taskId).then(() => {
      notify(messages.taskUndeleted(taskName));
    });
  };

  triggerDeleteTask = (taskId: number, taskName: string) => {
    const parentId = this.props.tasks.data[taskId].parentId;
    return this.handleDeleteTask(taskId, taskName, parentId)();
  };

  handleCancelDeleteTask = () => {
    clearTimeout(this.timeout);
  };

  handlePrintSingleTask = () => {
    window.open(`/t/${this.props.companyId}/task/print/${this.props.task.id}`);
  };

  handleClickOnParentTask = (e: React.MouseEvent<HTMLElement>) => {
    const { tasks, task } = this.props;
    this.handleClickOnTask?.(
      this.props.task.parentId,
      'info',
      tasks.data[task.parentId].viewToken,
      e
    );
  };

  handleUndraftTask = (includeSubtasks: boolean) => {
    this.setState({ loadingDraft: true });
    this.props
      .undraftTask(this.props.task.id, includeSubtasks)
      .then(() => {
        notify(i18n.t('operationDone', { ns: 'taskManager' }));
        this.setState({
          loadingDraft: false,
          foundDraftSubtask: this.checkForDraftSubtask(),
        });
      })
      .catch((err) => {
        display(err);
      });
  };

  handleUploadFile = () => {
    return this.props.getTask(this.props.task.id, true);
  };

  render() {
    const {
      company,
      companyId,
      relatedTemplate,
      parentId,
      projects,
      relatedProviders,
      tab,
      task,
      tasks,
      thisUser,
      users,
      providerItem,
      fields,
      embedded,
      thisUserId,
      projectId,
      isDirty,
      stickToSide,
      windowSize,
    } = this.props;
    const cntx = this.context;

    const { loadingDraft, foundDraftSubtask, editing, scrollToSubTask } =
      this.state;

    if (this.state.loading) {
      return (
        <div className="h-full flex">
          <EditorContainer stickToSide={stickToSide}>
            <LogoLoading />
          </EditorContainer>
        </div>
      );
    }
    const taskMembersId = this.taskMembers();
    const members: {
      [key: number]: IUserOption | IRoleOption;
    } = taskMembersId.reduce(
      (list: { [key: number]: IUserOption }, memberId) => {
        const userRoles = company?.members?.[memberId]?.roles;
        list[`USER_${memberId}`] = {
          userId: memberId,
          name: users?.[memberId]?.name || '',
          optionType: 'user',
          inactive: company?.members?.[memberId]?.inactive,
          roles:
            userRoles && Object.keys(userRoles || {}).length > 0
              ? Object.values(userRoles).map((role) => ({
                  name: role.name,
                  id: role.id,
                }))
              : [],
        };
        return list;
      },
      {}
    );

    Object.values(company?.roles || {})?.forEach((role) => {
      if (role.users.length > 0) {
        members[`ROLE_${role.id}`] = {
          roleId: role.id,
          name: role.displayName,
          optionType: 'role',
        };
      }
    });

    let templates: ITasks['data'] = {};
    let templateList: Array<ITask> = [];
    if (task) {
      const project = projects?.[task.projectId];
      if (project?.templates) {
        templateList = Object.values(tasks.data || {}).filter((item) =>
          project.templates.find(
            (template) =>
              template.taskId === item[1]?.id &&
              !item[1]?.archived &&
              template?.allowRoot
          )
        );
      }
      const templateChildren = company?.templates?.[task.templateId]?.children;
      if (templateChildren && templateChildren.length > 0) {
        templateList = Object.values(tasks.data).filter((item) =>
          templateChildren?.includes(item.id)
        );
      }
    } else if (this.state.projectId || this.props.projectId) {
      const templateProjectId = (this.state.projectId ||
        this.props.projectId) as number;
      const projectTemplates = projects[templateProjectId]?.templates;
      templateList = Object.values(tasks.data || {})?.filter((item) =>
        projectTemplates?.find(
          (template) =>
            template.taskId === item.id && !item.archived && template.allowRoot
        )
      );
    }
    templates = templateList.reduce(
      (obj, itm) => {
        obj[itm.id] = itm;
        return obj;
      },
      {} as ITasks['data']
    );
    Object.values(templates).forEach((item) => {
      if (item.archived) {
        delete templates[item.id];
      }
    });

    const projectMember = projects?.[this.state.projectId]?.myMembership;

    const permission = generateUserPermission(
      Number(thisUserId),
      task,
      !!projectMember && projectMember.canCreate,
      !!company && isCompanyOwnerOrSupport(thisUser, company),
      !!projectMember && projectMember.admin,
      !!company && isCompanyAdmin(thisUser, company)
    );

    let customTemplate: any;
    // task creation based on its parent and its template
    if (
      (this.props.templateId || this.state.templateId) &&
      (this.state.projectId || Number(this.props.projectId))
    ) {
      const templateId = this.props.templateId || this.state.templateId;
      const template: ITask = tasks.data[templateId];
      const parent = tasks.data[Number(parentId)];
      customTemplate =
        company &&
        createTaskFromTemplate(
          template,
          users,
          projects[this.state.projectId || Number(projectId)!],
          company,
          parent ?? undefined
        );
      if (providerItem && customTemplate)
        customTemplate.relatedProviderItems = [
          {
            id: providerItem.id,
            providerId: providerItem.providerId,
            title: providerItem.name,
            type: providerItem.type,
          },
        ];
      if (fields) {
        fields.forEach((preposedField) => {
          let found = false;
          customTemplate?.fields?.forEach((taskField: IField) => {
            if (taskField.name === preposedField.name) {
              found = true;
              taskField.value = preposedField.value;
            }
          });
          if (!found) {
            customTemplate?.fields.push(preposedField);
          }
        });
      }

      if (this.props.autoFillFields && customTemplate) {
        customTemplate.fields?.forEach((field: any) => {
          const autoFillValue =
            this.props.autoFillFields![field?.title || ''] ||
            this.props.autoFillFields![field.name];
          if (autoFillValue !== undefined) {
            if (field.type === 'multiSelect' && field.options) {
              const autoFillValues = Array.isArray(autoFillValue)
                ? autoFillValue
                : [autoFillValue];
              const selectedValues: string[] = [];

              autoFillValues.forEach((value) => {
                const matchingOption = Object.keys(field.options || {})?.find(
                  (option) =>
                    option
                      .toLowerCase()
                      .includes(String(value).toLowerCase()) ||
                    value.toLowerCase().includes(String(option).toLowerCase())
                );
                selectedValues.push(matchingOption || value);
              });

              field.value = selectedValues.join(',');
            } else {
              field.value = Array.isArray(autoFillValue)
                ? autoFillValue.length > 1
                  ? autoFillValue.join(',')
                  : autoFillValue[0]
                : autoFillValue;
            }
          }
        });

        if (
          !customTemplate.title &&
          this.props.autoFillFields[customTemplate.taskName]
        ) {
          const titleValue = this.props.autoFillFields[customTemplate.taskName];
          customTemplate.title = Array.isArray(titleValue)
            ? titleValue.length > 1
              ? titleValue.join(', ')
              : titleValue[0]
            : titleValue;
        }
      }
    }
    const parentIsDraft =
      task && task.parentId && tasks.data[task.parentId]?.draft;

    const canPublishTask =
      permission.publishTask &&
      task.draft &&
      (task.taskIsReadyToPublish ||
        (!task.haveTaskPublisher && task.allowDirectPublish));

    const hasEmptyRequiredField = task?.fields?.find(
      (field: IField) =>
        field.required &&
        !field.relatedToProgress &&
        (!field.value || /^\s*$/.test(field.value))
    );

    const canPublishSubTasks =
      permission.publishSubTasks &&
      (!task.draft || !task.haveTaskPublisher) &&
      (task.subTasksAreReadyToPublish || !task.haveSubTaskPublisher);

    const availableProjects =
      company && this.getAvailableProjects(company, projects);

    const conversationPanelToggle = (shouldShow: boolean) => {
      this.setState({ showConversation: shouldShow });
      let url = '';
      if (!embedded) {
        if (!shouldShow) {
          url = window.location.pathname.replaceAll('/conversation', '/info');
        } else {
          url = window.location.pathname.replaceAll('/info', '/conversation');
        }
      }
      if (!embedded) {
        navigate(url);
      }
    };

    const checkRequiredFieldsFulfilled = () => {
      const task = this.props.task;
      const listOfRequiredFields = this.props.task.requiredFields;

      const fieldMappings: { [key: string]: any } = {
        assignee: task.assignee,
        verifier:
          Object.keys(task.verifiers || {}).length > 0 ? task.verifiers : null,
        follower: task.followers,
        publisher: task.taskPublisher,
        subtaskPublisher: task.subTaskPublisher,
        startDate: task.startDate,
        dueDate: task.dueDate,
        relatedItem:
          (task.relatedProviderItems || []).length > 0
            ? task.relatedProviderItems
            : null,
      };

      return (
        listOfRequiredFields?.every((field) => fieldMappings[field]) ?? true
      );
    };

    return (
      <div
        style={
          this.props.embedded
            ? {
                borderRadius: this.props.isMobile ? 0 : '1.25rem',
                overflow: 'hidden',
                width: '100%',
                height: '100%',
              }
            : {
                borderRadius: this.props.isMobile ? 0 : '1.25rem',
                overflow: 'hidden',
                height: `${(cntx as any).openItems.length > 0 ? (windowSize === 'large' ? 'calc(100% - 3.5rem)' : 'calc(100% - 4rem)') : '100%'}`,
              }
        }
      >
        {isDirty && <Beforeunload onBeforeunload={() => ' '} />}
        <Helmet>
          <title>
            {task
              ? `«${task.textTitle || task.title}»`
              : (i18n.t('newTask', { ns: 'taskManager' }) as string)}
          </title>
          <meta
            name="description"
            content={
              task
                ? `«${task.textTitle}»`
                : i18n.t('newTask', { ns: 'taskManager' })
            }
          />
        </Helmet>
        <EditorContainer stickToSide={stickToSide}>
          {
            <TaskEditorHeader
              projectName={
                task
                  ? projects?.[task.projectId]?.name
                  : projects?.[projectId!]?.name || ''
              }
              editing={this.state.editing}
              task={task}
              companyId={company?.id}
              embedded={embedded}
              conversationPanelToggle={conversationPanelToggle.bind(this)}
              onCancel={this.handleClose.bind(this)}
              scrollToSubtask={this.handleScrollToSubtask}
              permission={permission}
              onPrintSingleTask={this.handlePrintSingleTask}
              isCompanyAdmin={!!company && isCompanyAdmin(thisUser, company)}
              isCompanySupport={
                !!company && isCompanyOwnerOrSupport(thisUser, company)
              }
              handleSaveTask={this.handleSaveTask}
              onArchiveOrRestoring={this.handleArchiveOrRestoring}
              onShowPreferencesModal={this.handleShowPreferencesModal}
              handleClickOnEdit={this.handleClickOnEdit}
              onDuplicateTask={this.handleDuplicateTask}
              sendMessageToAssignee={this.handleSendMessageToAssignee}
              parentId={parentId}
              tasks={tasks}
              templateId={this.props.templateId || this.state.templateId}
              users={users}
              hideClose={
                !!this.props.selectedSubTaskId || this.props.directTask
              }
              onRestoreTask={this.handleRestoreTask}
              userId={thisUser.userId}
              onFileUploaded={this.handleUploadFile}
              conversationToken={this.props.task?.conversationSendToken}
              onDraftTask={this.handleDraftTask}
              onDeleteTask={this.triggerDeleteTask}
              onChangeProgress={this.handleChangeProgress}
              onSetAssigneeIdToShow={this.handleSetActiveAssigneeIdToShow}
            />
          }
          {task ? (
            <Fragment>
              {(task.draft || foundDraftSubtask.found) && (
                <TaskDraftBox>
                  <p
                    style={{
                      float: languageDirection() === 'rtl' ? 'right' : 'left',
                      margin: '0.5rem',
                    }}
                  >
                    {(() => {
                      if (!checkRequiredFieldsFulfilled()) {
                        return i18n.t('requiredFields', {
                          ns: 'taskManager',
                        }) as string;
                      } else if (task.draft) {
                        let undraftHint = '';
                        if (task.haveTaskPublisher) {
                          undraftHint = this.getUndraftHintForTask(
                            task,
                            users,
                            undraftHint,
                            permission
                          );
                        } else if (task.haveSubTaskPublisher) {
                          undraftHint = this.getUndraftHintForSubTask(
                            task,
                            users,
                            undraftHint,
                            permission
                          );
                        }
                        return (
                          messages.taskIsDraft(task.taskName) +
                          (undraftHint ? ' - ' + undraftHint : '')
                        );
                      } else {
                        let undraftHint = '';
                        if (task.haveSubTaskPublisher) {
                          undraftHint = this.getUndraftHintForSubTask(
                            task,
                            users,
                            undraftHint,
                            permission
                          );
                        }
                        return (
                          messages.taskHasDraftSubtask(
                            task.taskName,
                            task.subTasksTitle!
                          ) + (undraftHint ? ' - ' + undraftHint : '')
                        );
                      }
                    })()}
                  </p>

                  {checkRequiredFieldsFulfilled() &&
                    ((!parentIsDraft && (
                      <div
                        style={{
                          float:
                            languageDirection() === 'rtl' ? 'left' : 'right',
                          margin: '0.2rem ',
                        }}
                      >
                        {canPublishTask &&
                          (hasEmptyRequiredField ? (
                            <p>
                              {messages.fillRequiredFields(
                                messages.undraftTask(
                                  (relatedTemplate || task).undraftTaskTitle,
                                  task.taskName
                                )
                              )}
                            </p>
                          ) : (
                            <Button
                              style={{
                                float:
                                  languageDirection() === 'rtl'
                                    ? 'right'
                                    : 'left',
                                margin: '.2rem',
                              }}
                              onClick={() => this.handleUndraftTask(false)}
                              color="red"
                              loading={loadingDraft}
                            >
                              {messages.undraftTask(
                                (relatedTemplate || task).undraftTaskTitle,
                                task.taskName
                              )}
                            </Button>
                          ))}
                        {canPublishSubTasks && (
                          <Button
                            style={{
                              float:
                                languageDirection() === 'rtl'
                                  ? 'right'
                                  : 'left',
                              margin: '.2rem',
                            }}
                            onClick={() => this.handleUndraftTask(true)}
                            color="red"
                            loading={loadingDraft}
                          >
                            {task.draft
                              ? messages.undraftTaskAndSubtask(
                                  (relatedTemplate || task)
                                    .undraftTaskAndSubtaskTitle,
                                  task.taskName,
                                  (relatedTemplate || task).subTasksTitle
                                )
                              : messages.undraftTask(
                                  (relatedTemplate || task)
                                    .undraftTaskAndSubtaskTitle,
                                  task.subTasksTitle
                                )}
                          </Button>
                        )}
                      </div>
                    )) ||
                      (permission.edit && (
                        <div
                          style={{
                            float:
                              languageDirection() === 'rtl' ? 'right' : 'left',
                            margin: '0.5rem',
                          }}
                        >
                          <Icon className="right" type="info" />
                          {messages.parentShouldBeUndraftedFirst(
                            tasks.data[task.parentId].taskName
                          )}
                        </div>
                      )))}
                </TaskDraftBox>
              )}
              {task.relatedTasks?.find((it) => it.blocksProgress) && (
                <TaskDependencyNotMeetBox>
                  {
                    i18n.t('taskDependencyNotMeet', {
                      ns: 'taskManager',
                      taskName: task.taskName,
                    }) as string
                  }
                </TaskDependencyNotMeetBox>
              )}
              <div className="flex flex-row gap-2 max-w-screen-lg overflow-x-scroll h-full">
                <TaskEditor
                  showSettingsModal={() =>
                    this.handleShowPreferencesModal(true)
                  }
                  embedded={embedded}
                  tab={(tab || 'info') as Tab}
                  task={task}
                  tasks={tasks}
                  users={this.props.users!}
                  searchTasks={this.props.searchTasks}
                  members={members}
                  onSave={this.handleSaveTask}
                  handleClickOnTask={this.handleClickOnTask}
                  templates={{
                    data: templates,
                  }}
                  scrollToSubTask={scrollToSubTask}
                  cancelEdit={this.handleCancelEdit}
                  permission={permission}
                  thisUser={thisUser}
                  templateName={templates[task.templateId]?.taskName || ''}
                  relatedProviders={
                    Object.keys(relatedProviders || {})?.length > 0
                      ? relatedProviders
                      : null
                  }
                  windowSize={windowSize}
                  loadingSave={this.state.loadingSave}
                  onUpdateAssignment={this.handleUpdateAssignmentTask}
                  onUpdateAssignmentHistoryList={
                    this.handleUpdateAssignmentHistoryListTask
                  }
                  onUpdateTask={this.handleUpdateTask}
                  companyId={companyId}
                  company={company}
                  project={projects?.[task.projectId]}
                  editing={editing}
                  relatedTaskTemplate={relatedTemplate || task}
                  foundDraftSubtask={foundDraftSubtask.found}
                  addMultipleMembersToCompany={
                    this.props.addMultipleMembersToCompany
                  }
                  token={this.props.token}
                  reFetchTask={(id) => this.props.getTask(id, true)}
                  setDirty={this.props.setDirty}
                  isDirty={this.props.isDirty}
                  safeNavigate={this.props.safeNavigate}
                  notifyGuide={this.props.addGuideToList}
                  selectedSubTaskId={this.props.selectedSubTaskId}
                  onDeleteTask={this.triggerDeleteTask}
                  onDraftTask={this.handleDraftTask}
                  onFileUploaded={this.handleUploadFile}
                  assigneeIdToShow={this.state.activeAssigneeIdToShow}
                  onSetAssigneeIdToShow={this.handleSetActiveAssigneeIdToShow}
                />
              </div>
              {this.state.preferencesModal && (
                <TaskPreferences
                  projects={this.props.projects}
                  moveToProject={this.props.moveToProject}
                  show={this.state.preferencesModal}
                  task={taskManipulate.storeToState(task, users)}
                  onClose={() => this.handleShowPreferencesModal(false)}
                  onSearchTask={this.handleSearchTask}
                  onDeleteTask={this.triggerDeleteTask}
                  onRestoreTask={this.handleRestoreTask}
                  onDraftTask={this.handleDraftTask}
                  onCancelDeleteTask={this.handleCancelDeleteTask}
                  onChangeParentTask={this.handleChangeParentTask}
                  onArchiveOrRestoring={this.handleArchiveOrRestoring}
                  onChangePreferencesInput={this.handleModifyTask}
                  parentTitle={tasks?.data[task.parentId]?.title}
                  permission={permission}
                />
              )}
            </Fragment>
          ) : (
            <Fragment>
              <div
                style={{
                  width: '100%',
                  position: 'relative',
                }}
                className="flex gap-3 items-center"
              >
                {Number(this.props.parentId) ? (
                  <div></div>
                ) : window.location.pathname?.includes('project') ? (
                  <div></div>
                ) : (
                  <div
                    className="flex items-center my-3 gap-3"
                    style={{ flexBasis: '50%' }}
                  >
                    <label htmlFor="projectId" className="col s12 m1 px-3">
                      {i18n.t('project', { ns: 'taskManager' }) as string}
                    </label>
                    <select
                      className="browser-default"
                      id="projectId"
                      name="projectId"
                      value={this.state.projectId}
                      onChange={this.handleSelectChange.bind(this)}
                    >
                      <option value="0" disabled={true}>
                        {
                          i18n.t('chooseAProject', {
                            ns: 'taskManager',
                          }) as string
                        }
                      </option>
                      {availableProjects!.map((pId) => (
                        <option key={pId.id} value={pId.id}>
                          {projects[pId.id]?.name || ''}
                        </option>
                      ))}
                    </select>
                  </div>
                )}
                {!this.props.templateId &&
                  Object.keys(templates).length > 1 && (
                    <div style={{ flexBasis: '50%' }} className="flex gap-3">
                      <label htmlFor="templateId" className="col s12 m1">
                        {
                          i18n.t('template', {
                            ns: 'taskManager',
                          }) as string
                        }
                      </label>
                      <select
                        className="browser-default col s12 m5"
                        id="templateId"
                        name="templateId"
                        value={this.props.templateId || this.state.templateId}
                        onChange={this.handleSelectChange.bind(this)}
                      >
                        <option value="0" disabled={true}>
                          {
                            i18n.t('chooseATemplate', {
                              ns: 'taskManager',
                            }) as string
                          }
                        </option>
                        {Object.values(templates).map((template) => (
                          <option key={template.id} value={template.id}>
                            {template.taskName}
                          </option>
                        ))}
                      </select>
                    </div>
                  )}
                {/*<HoverIcon
                  type={'x'}
                  style={{ position: 'absolute', top: '10px', left: '10px' }}
                  onClick={this.props.onCloseTask}
                  color={'red'}
                />*/}
              </div>
              {customTemplate &&
              (this.props.templateId || this.state.templateId) ? (
                <TaskEditor
                  showSettingsModal={() =>
                    this.handleShowPreferencesModal(true)
                  }
                  embedded={embedded}
                  tab="info"
                  task={customTemplate}
                  tasks={tasks}
                  parentId={parentId}
                  members={members}
                  users={users}
                  company={company}
                  searchTasks={this.props.searchTasks}
                  onSave={this.handleSaveTask}
                  cancelEdit={
                    this.props.onCloseTask ||
                    (() => {
                      /*do nothing*/
                    })
                  }
                  windowSize={windowSize}
                  permission={permission}
                  loadingSave={this.state.loadingSave}
                  relatedProviders={
                    Object.keys(relatedProviders || {}).length > 0
                      ? relatedProviders
                      : null
                  }
                  templateName={
                    templates[this.state.templateId || this.props.templateId!]
                      ?.taskName
                  }
                  thisUser={thisUser}
                  onUpdateTask={this.handleUpdateTask}
                  companyId={companyId}
                  project={
                    this.state.projectId
                      ? projects[this.state.projectId]
                      : undefined
                  }
                  editing={editing}
                  relatedTaskTemplate={customTemplate}
                  addMultipleMembersToCompany={
                    this.props.addMultipleMembersToCompany
                  }
                  token={this.props.token}
                  reFetchTask={(id) => this.props.getTask(id, true)}
                  setDirty={this.props.setDirty}
                  isDirty={this.props.isDirty}
                  safeNavigate={this.props.safeNavigate}
                  notifyGuide={this.props.addGuideToList}
                  onDeleteTask={this.triggerDeleteTask}
                  onDraftTask={this.handleDraftTask}
                  onFileUploaded={this.handleUploadFile}
                  assigneeIdToShow={this.state.activeAssigneeIdToShow}
                  onSetAssigneeIdToShow={this.handleSetActiveAssigneeIdToShow}
                />
              ) : projectId || this.state.projectId ? (
                <p className="px-8 py-4" style={{ color: black }}>
                  {
                    i18n.t('noTaskCanBeCreated', {
                      ns: 'taskManager',
                    }) as string
                  }
                </p>
              ) : (
                <p className="px-8 py-4" style={{ color: black }}>
                  {
                    i18n.t('pleaseSelectAProject', {
                      ns: 'taskManager',
                    }) as string
                  }
                </p>
              )}
            </Fragment>
          )}
        </EditorContainer>
        {task?.template === false && (
          <div
            className={`absolute ${this.state.showConversation ? 'w-full h-full' : `cursor-pointer ${languageDirection() === 'rtl' ? 'rounded-r-lg' : 'rounded-l-lg'} bg-gray-400 bg-opacity-20 hover:bg-opacity-90 hover:text-white`}`}
            style={{
              zIndex: 5,
              top: this.state.showConversation ? 0 : undefined,
              bottom: this.state.showConversation ? undefined : '10%',
              left: languageDirection() === 'rtl' ? 0 : undefined,
              right: languageDirection() === 'rtl' ? undefined : 0,
            }}
            onClick={() => {
              conversationPanelToggle(true);
            }}
          >
            {this.state.showConversation ? (
              <div className="w-full h-full">
                <div
                  className="absolute cursor-pointer"
                  onClick={(e) => {
                    e.stopPropagation();
                    conversationPanelToggle(false);
                  }}
                  style={{
                    top: '10px',
                    left: '10px',
                    zIndex: 10000 + 112,
                  }}
                >
                  <Icon
                    type="x-circle"
                    style={{
                      fontSize: '21px',
                      color: 'black',
                    }}
                  />
                </div>
                <div
                  className="absolute w-full h-full top-0 right-0"
                  style={{
                    zIndex: 10000 + 110,
                    width: 'calc(100% )',
                  }}
                ></div>
                <div
                  className="absolute right-0 top-0 flex h-full bg-gray-100 bg-opacity-90"
                  style={{
                    zIndex: 10000 + 111,
                    width: 'calc(100%)',
                    borderRadius: '20px',
                  }}
                >
                  <TaskConversation
                    readToken={task.conversationReadToken}
                    sendToken={task.conversationSendToken}
                    conversationId={task.conversationId}
                    projectId={task.projectId}
                    messageSent={(msg: any) => {
                      if (msg.type === 'file')
                        this.props.getTask(task.id, true);
                    }}
                  />
                </div>
              </div>
            ) : (
              <p className="rotate-90 px-0 py-8" style={{ color: black }}>
                {messages.conversation('')}
              </p>
            )}
          </div>
        )}
      </div>
    );
  }

  private handleClose() {
    if (
      this.props?.isDirty &&
      !confirm(i18n.t('changesWillBeLost', { ns: 'taskManager' }) as string)
    )
      return;
    this.props?.setDirty?.(Number(this.props.taskId) || 0, false);
    return this.props?.onCloseTask
      ? this.props.onCloseTask()
      : this.handleClickOnTask?.();
  }
  handleScrollToSubtask = () => {
    this.setState({ scrollToSubTask: (this.state.scrollToSubTask || 0) + 1 });
  };

  private getUndraftHintForSubTask(
    task: ITask,
    users: IUsers['map'],
    undraftHint: string,
    permission: IPermission
  ) {
    if (task.subTasksAreReadyToPublish) {
      const taskPublisherName =
        users[Number(task.subTaskPublisher?.userId)]?.name;
      undraftHint = messages.readyPublishSubTaskBy(
        task.readyToPublishSubTaskTitle,
        task.subTaskTitle!,
        taskPublisherName,
        task.subTaskPublisherTitle!
      );
    } else if (!permission.publishSubTasks && permission.edit)
      undraftHint = messages.setTaskStateToReadyPublishSubTasks(
        task.readyToPublishSubTaskTitle!,
        task.taskName,
        task.subTaskTitle!
      );
    return undraftHint;
  }

  private getUndraftHintForTask(
    task: ITask,
    users: IUsers['map'],
    undraftHint: string,
    permission: IPermission
  ) {
    if (task.taskIsReadyToPublish) {
      const taskPublisherName = users[Number(task.taskPublisher?.userId)]?.name;
      undraftHint = messages.readyPublishTaskBy(
        task.readyToPublishTaskTitle,
        task.taskName,
        taskPublisherName,
        task.taskPublisherTitle!
      );
    } else if (!permission.publishTask && permission.edit)
      undraftHint = messages.setTaskStateToReadyPublish(
        task.readyToPublishTaskTitle!,
        task.taskName
      );
    return undraftHint;
  }

  private getAvailableProjects(company: ICompany, projects: TProjects) {
    return (
      Object.values(company?.projects || {})?.filter((pId) => {
        if (
          (!isCompanyOwnerOrSupport(this.props.thisUser, company) &&
            !projects?.[pId.id]?.myMembership?.canCreate) ||
          projects?.[pId.id]?.archived
        )
          return false;
        if (this.props.templateId) {
          return projects[pId.id]?.templates?.find(
            (it: any) => it.taskId === this.props.templateId
          );
        }
        return true;
      }) ?? []
    );
  }
}

const mapStateToProps: MapStateToProps<StateToProps, OwnProps, RootState> = (
  state,
  props
) => {
  const companyId = Number(props.companyId);
  const taskId = Number(props.taskId);
  const tasks = state.tasks;
  const task =
    (props.task ?? props.taskId !== 'new') ? tasks.data[taskId] : undefined;
  const company = state.companies.data[companyId];
  const companyOwnerId = company?.owner?.userId;
  const projects = company?.projects;
  const isDirty = (state.tasks.dirty as Array<number>)?.includes(taskId || 0);
  const relatedTemplate = state.tasks.data[task ? task.templateId : taskId];
  const users = state.users.map;
  const relatedProviders = state.companies.data[companyId]?.relatedProviders;
  const thisUser = state.thisUser;
  const token = getAccessToken(state);
  const thisUserId = Number(thisUser.userId);

  return {
    isDirty,
    task,
    tasks,
    users,
    company,
    projects,
    thisUser,
    thisUserId,
    companyOwnerId,
    relatedProviders,
    relatedTemplate,
    token,
  };
};

const mapDispatchToProps: MapDispatchToProps<DispatchToProps, OwnProps> = (
  dispatch: ThunkDispatch<any, never, any>
) => ({
  setSingleTaskAccessToken: (token: string) =>
    dispatch(setSingleTaskAccessToken(token)),
  createTask: (task: ITask, dontSendMessages = false) =>
    appDispatch(createTask({ task, dontSendMessages })),
  deleteSingleTask: (taskId: number) =>
    appDispatch(deleteSingleTask({ taskId })),
  restoreTask: (taskId: number) => appDispatch(restoreTask({ taskId })),
  getTask: (taskId: number, force?: boolean) =>
    dispatch(
      getTask({
        taskId,
        includeAssignmentHistory: true,
        includeProgressHistory: false,
        force,
      })
    ).unwrap(),
  getProject: (projectId: number, companyId: number) =>
    appDispatch(getProject({ projectId, companyId })),
  markTaskAssignment: (assignment: IAssignmentView) =>
    appDispatch(markTaskAssignment({ assignment })),
  requireDocument: (documentId: number) =>
    appDispatch(requireDocument({ documentId })),
  requireSeveralUser: (membersId: number[]) =>
    dispatch(requireSeveralUser({ usersList: membersId })).unwrap(),
  searchTasks: (params: ISearchParams) => appDispatch(searchTasks({ params })),
  updateTask: (task: ITask, dontSendMessages = false) =>
    appDispatch(updateTask({ task, dontSendMessages })),
  moveToProject: (taskId: number, projectId: number) =>
    appDispatch(moveToProject({ taskId, projectId })),
  undraftTask: (taskId: number, includeSubTasks: boolean) =>
    appDispatch(undraftTask({ taskId, includeSubTasks })),
  draftTask: (taskId: number) => appDispatch(draftTask({ taskId })),
  setDirty: (taskId: number, isDirty: boolean) =>
    appDispatch(setDirty({ taskId, isDirty })),
  duplicateTask: (taskId: number) =>
    appDispatch(duplicateTask({ taskIds: [taskId] })).then((ret: ITask[]) => {
      return ret[0];
    }),
  sendMessageToAssignee: (taskId: number, message: string) =>
    appDispatch(sendMessageToAssignee({ taskId, message })).then(
      (ret: ITask[]) => {
        return ret[0];
      }
    ),
  addGuideToList: (key: string | string[]) => appDispatch(addGuideToList(key)),
  addMultipleMembersToCompany: (
    invitedMembers: IInvitedMember[],
    forceRename: boolean,
    companyId: number
  ) =>
    appDispatch(
      batchAddMembersToCompany({ invitedMembers, forceRename, companyId })
    ),
  markTaskAssignmentHistory: (
    assignmentId: number,
    assignmentHistory: IAssignmentHistory[]
  ) =>
    appDispatch(markTaskAssignmentHistory({ assignmentId, assignmentHistory })),
});

const TaskEditorContWithSafeNavigate: React.FC<ComponentProps> = (props) => {
  const safeNavigate = useSafeNavigate();

  return <TaskEditorCont {...props} safeNavigate={safeNavigate} />;
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(TaskEditorContWithSafeNavigate);
